export { BaseDynamicComponent } from './base-dynamic-component';
export { CSSBackdrop } from './css-backdrop';
export { CSSDialogContainer } from './css-dialog-container';
// export { FadeInBackdrop } from './fade-in-backdrop';
// export { SplitScreenBackdrop } from './split-screen-backdrop';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./.tmp/angular2-modal/src/components/index.js
// module id = 4
// module chunks = 0